module.exports = __webpack_public_path__ + "static/media/Welspun_Hospitality_Textiles.4ceae371.jpg";